
export const HomeIcon = (props: React.SVGProps<SVGSVGElement>) => {
  props = {
    ...props,
    color: props.color,
  };
  return (
    <svg
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0L0 5.33333V16H4.375V9.77778H9.625V16H14V5.33333L7 0Z"
        fill="currentColor"
      />
    </svg>
  );
};
